// Import the zustand store instance
import useQuoteStore from "../store/QuoteStore";
import useAppStateStore from "../../../shared/store/AppStateStore";

const Tq6Mapper = {
  get() {
    const STATE = useAppStateStore.getState();
    // Get fresh data when getting values
    const vehicle = useQuoteStore.getState().quote?.risk?.vehicles[0] ?? {};
    const driver = useQuoteStore.getState().quote?.risk?.drivers?.[0] ?? {};

    const claims = STATE.claims;
    const lookupGarage = STATE.lookupAddressGarage ?? null;

    return {
      RegOwner: vehicle.ownerId
        ? vehicle.ownerId === "1"
          ? "Yes"
          : "No"
        : null,
      owner: vehicle.ownerId ? { value: vehicle.ownerId } : "",
      Regkeeper: vehicle.keeperId
        ? vehicle.keeperId === "1"
          ? "Yes"
          : "No"
        : null,
      keeper: vehicle.keeperId ? { value: vehicle.keeperId } : "",
      marketValue: vehicle.estimatedValue === 0 ? null : vehicle.estimatedValue,
      locOverNight:
        vehicle.overnightParkingId && vehicle.overnightParkingId !== "4"
          ? { value: vehicle.overnightParkingId }
          : null,
      overNightHome:
        vehicle?.garageAddress?.postcode &&
        driver?.address?.postcode &&
        vehicle.garageAddress.postcode === driver.address.postcode
          ? "Yes"
          : "No",
      // AddressLookup default values (garage)
      lookUpAddress: lookupGarage ?? null,
      address:
        lookupGarage?.house ??
        lookupGarage?.houseNo ??
        vehicle?.garageAddress?.houseNo ??
        "",
      postcode: lookupGarage?.postcode ?? vehicle?.garageAddress?.postcode ?? "",
      AdditionalClaims5Years: claims ?? null,
    };
  },

  set(data) {
    const { updateField } = useQuoteStore.getState();
    const STATE = useAppStateStore.getState();
    const setClaims = STATE.setClaims;
    const setLookupAddressGarage = STATE.setLookupAddressGarage;
    const driver = useQuoteStore.getState().quote?.risk?.drivers?.[0] ?? {};
    if (data.RegOwner == "No") {
      updateField("risk.vehicles.0.ownerId", data.owner?.value ?? "1");
    }
    if (data.RegOwner == "Yes") {
      updateField("risk.vehicles.0.ownerId", "1");
    }
    if (data.Regkeeper == "No") {
      updateField("risk.vehicles.0.keeperId", data.keeper?.value ?? "1");
    }
    if (data.Regkeeper == "Yes") {
      updateField("risk.vehicles.0.keeperId", "1");
    }
    updateField("risk.vehicles.0.estimatedValue", data.marketValue);
    updateField("risk.vehicles.0.overnightParkingId", data.locOverNight?.value);

    if (data.overNightHome === "No") {
      // Not kept at home, use selected lookup address (full object)
      const garageAddress = data.lookUpAddress ?? null;
      if (garageAddress) {
        updateField("risk.vehicles.0.garageAddress", {
          ...useQuoteStore.getState().quote?.risk?.vehicles[0]?.garageAddress,
          houseNo: garageAddress.house ?? garageAddress.houseNo ?? "",
          street: garageAddress.street ?? "",
          city: garageAddress.city ?? "",
          county: garageAddress.county ?? "",
          postcode: garageAddress.postcode ?? "",
        });
      } else {
        // fallback: keep existing but update postcode from field if user typed it
        updateField("risk.vehicles.0.garageAddress", {
          ...useQuoteStore.getState().quote?.risk?.vehicles[0]?.garageAddress,
          postcode: data.postcode ?? "",
        });
      }
    } else {
      // Kept at home, use driver's address object directly
      updateField("risk.vehicles.0.garageAddress", driver.address);
    }

    updateField(
      "risk.cover.drivingRestrictionId",
      data.drivingRestrictionId ?? "",
    );
    updateField("risk.cover.requestedVolExcess", data.volAccess?.label ?? 0);
    updateField(
      "risk.cover.requestedVolExcessId",
      data.volAccess?.value ?? "00",
    );
    updateField("risk.cover.previousInsurance", data.previousInsurance ?? null);
    setClaims(data.AdditionalClaims5Years);
    setLookupAddressGarage?.(data.lookUpAddress ?? null);
  },
};

export default Tq6Mapper;
